/**
 * Optimizely Feature Flag Keys
 *
 * Centralized constants for all Optimizely feature flags and experiments.
 * Update this file when adding new flags in the Optimizely dashboard.
 */

export const OPTIMIZELY_FLAGS = {
	FACILITY_PAGE_TESTING: 'ssdc_facility_redesign_ab_testing_26Q1',
	CLP_TESTING: 'ssdc_clp_ab_testing_26Q1',
	/** Facility page A/A test for reporting verification */
	FACILITY_PAGE_AA_TEST: 'facility_page_aa_test',
	/**
	 * SF-22689: mobile sticky Reserve Now bar + jump nav A/B test.
	 * The trailing underscore and dash/underscore mix look like a typo but
	 * are not - this is confirmed to match the key exactly as configured in
	 * the Optimizely dashboard. Do not "clean up" this string; if the
	 * experiment ever seems to silently never render for anyone, verify
	 * against the dashboard before assuming this key is wrong.
	 */
	MOBILE_STICKY_ATC: 'sf-22689-frontend-mobile_sticky_atc_',
};

/** Variation keys for OPTIMIZELY_FLAGS.FACILITY_PAGE_AA_TEST */
export const FACILITY_PAGE_AA_TEST_VARIATIONS = {
	VARIATION: 'variation',
	CONTROL: 'control',
};

/** Variation keys for OPTIMIZELY_FLAGS.MOBILE_STICKY_ATC */
export const MOBILE_STICKY_ATC_VARIATIONS = {
	VARIATION: 'variation',
	CONTROL: 'control',
};

export default OPTIMIZELY_FLAGS;
